"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/services/createDinero.ts
var createDinero_exports = {};
__export(createDinero_exports, {
  createDinero: () => createDinero
});
module.exports = __toCommonJS(createDinero_exports);

// node_modules/dinero.js/build/esm/dinero.js
var Defaults = {
  defaultAmount: 0,
  defaultCurrency: "USD",
  defaultPrecision: 2
};
var Globals = {
  globalLocale: "en-US",
  globalFormat: "$0,0.00",
  globalRoundingMode: "HALF_EVEN",
  globalFormatRoundingMode: "HALF_AWAY_FROM_ZERO",
  globalExchangeRatesApi: {
    endpoint: void 0,
    headers: void 0,
    propertyPath: void 0
  }
};
function _typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function(obj2) {
      return typeof obj2;
    };
  } else {
    _typeof = function(obj2) {
      return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    };
  }
  return _typeof(obj);
}
function _toArray(arr) {
  return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest();
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr))
    return arr;
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter))
    return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++)
    arr2[i] = arr[i];
  return arr2;
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var Static = {
  normalizePrecision: function normalizePrecision(objects) {
    var highestPrecision = objects.reduce(function(a, b) {
      return Math.max(a.getPrecision(), b.getPrecision());
    });
    return objects.map(function(object) {
      return object.getPrecision() !== highestPrecision ? object.convertPrecision(highestPrecision) : object;
    });
  },
  minimum: function minimum(objects) {
    var _objects = _toArray(objects), firstObject = _objects[0], tailObjects = _objects.slice(1);
    var currentMinimum = firstObject;
    tailObjects.forEach(function(obj) {
      currentMinimum = currentMinimum.lessThan(obj) ? currentMinimum : obj;
    });
    return currentMinimum;
  },
  maximum: function maximum(objects) {
    var _objects2 = _toArray(objects), firstObject = _objects2[0], tailObjects = _objects2.slice(1);
    var currentMaximum = firstObject;
    tailObjects.forEach(function(obj) {
      currentMaximum = currentMaximum.greaterThan(obj) ? currentMaximum : obj;
    });
    return currentMaximum;
  }
};
function isNumeric(value) {
  return !isNaN(parseInt(value)) && isFinite(value);
}
function isPercentage(percentage) {
  return isNumeric(percentage) && percentage <= 100 && percentage >= 0;
}
function areValidRatios(ratios) {
  return ratios.length > 0 && ratios.every(function(ratio) {
    return ratio >= 0;
  }) && ratios.some(function(ratio) {
    return ratio > 0;
  });
}
function isEven(value) {
  return value % 2 === 0;
}
function isFloat(value) {
  return isNumeric(value) && !Number.isInteger(value);
}
function countFractionDigits() {
  var number = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
  var stringRepresentation = number.toString();
  if (stringRepresentation.indexOf("e-") > 0) {
    return parseInt(stringRepresentation.split("e-")[1]);
  } else {
    var fractionDigits = stringRepresentation.split(".")[1];
    return fractionDigits ? fractionDigits.length : 0;
  }
}
function isHalf(number) {
  return Math.abs(number) % 1 === 0.5;
}
function getJSON(url) {
  var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return new Promise(function(resolve, reject) {
    var request = Object.assign(new XMLHttpRequest(), {
      onreadystatechange: function onreadystatechange() {
        if (request.readyState === 4) {
          if (request.status >= 200 && request.status < 400)
            resolve(JSON.parse(request.responseText));
          else
            reject(new Error(request.statusText));
        }
      },
      onerror: function onerror() {
        reject(new Error("Network error"));
      }
    });
    request.open("GET", url, true);
    setXHRHeaders(request, options.headers);
    request.send();
  });
}
function setXHRHeaders(xhr) {
  var headers = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  for (var header in headers) {
    xhr.setRequestHeader(header, headers[header]);
  }
  return xhr;
}
function isUndefined(value) {
  return typeof value === "undefined";
}
function flattenObject(object) {
  var separator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ".";
  var finalObject = {};
  Object.entries(object).forEach(function(item) {
    if (_typeof(item[1]) === "object") {
      var flatObject = flattenObject(item[1]);
      Object.entries(flatObject).forEach(function(node) {
        finalObject[item[0] + separator + node[0]] = node[1];
      });
    } else {
      finalObject[item[0]] = item[1];
    }
  });
  return finalObject;
}
function isThenable(value) {
  return Boolean(value) && (_typeof(value) === "object" || typeof value === "function") && typeof value.then === "function";
}
function Calculator() {
  var floatMultiply = function floatMultiply2(a, b) {
    var getFactor = function getFactor2(number) {
      return Math.pow(10, countFractionDigits(number));
    };
    var factor = Math.max(getFactor(a), getFactor(b));
    return Math.round(a * factor) * Math.round(b * factor) / (factor * factor);
  };
  var roundingModes = {
    HALF_ODD: function HALF_ODD(number) {
      var rounded = Math.round(number);
      return isHalf(number) ? isEven(rounded) ? rounded - 1 : rounded : rounded;
    },
    HALF_EVEN: function HALF_EVEN(number) {
      var rounded = Math.round(number);
      return isHalf(number) ? isEven(rounded) ? rounded : rounded - 1 : rounded;
    },
    HALF_UP: function HALF_UP(number) {
      return Math.round(number);
    },
    HALF_DOWN: function HALF_DOWN(number) {
      return isHalf(number) ? Math.floor(number) : Math.round(number);
    },
    HALF_TOWARDS_ZERO: function HALF_TOWARDS_ZERO(number) {
      return isHalf(number) ? Math.sign(number) * Math.floor(Math.abs(number)) : Math.round(number);
    },
    HALF_AWAY_FROM_ZERO: function HALF_AWAY_FROM_ZERO(number) {
      return isHalf(number) ? Math.sign(number) * Math.ceil(Math.abs(number)) : Math.round(number);
    },
    DOWN: function DOWN(number) {
      return Math.floor(number);
    }
  };
  return {
    add: function add(a, b) {
      return a + b;
    },
    subtract: function subtract(a, b) {
      return a - b;
    },
    multiply: function multiply(a, b) {
      return isFloat(a) || isFloat(b) ? floatMultiply(a, b) : a * b;
    },
    divide: function divide(a, b) {
      return a / b;
    },
    modulo: function modulo(a, b) {
      return a % b;
    },
    round: function round(number) {
      var roundingMode = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "HALF_EVEN";
      return roundingModes[roundingMode](number);
    }
  };
}
var calculator = Calculator();
function Format(format) {
  var matches = /^(?:(\$|USD)?0(?:(,)0)?(\.)?(0+)?|0(?:(,)0)?(\.)?(0+)?\s?(dollar)?)$/gm.exec(format);
  return {
    getMatches: function getMatches() {
      return matches !== null ? matches.slice(1).filter(function(match) {
        return !isUndefined(match);
      }) : [];
    },
    getMinimumFractionDigits: function getMinimumFractionDigits() {
      var decimalPosition = function decimalPosition2(match) {
        return match === ".";
      };
      return !isUndefined(this.getMatches().find(decimalPosition)) ? this.getMatches()[calculator.add(this.getMatches().findIndex(decimalPosition), 1)].split("").length : 0;
    },
    getCurrencyDisplay: function getCurrencyDisplay() {
      var modes = {
        USD: "code",
        dollar: "name",
        $: "symbol"
      };
      return modes[this.getMatches().find(function(match) {
        return match === "USD" || match === "dollar" || match === "$";
      })];
    },
    getStyle: function getStyle() {
      return !isUndefined(this.getCurrencyDisplay(this.getMatches())) ? "currency" : "decimal";
    },
    getUseGrouping: function getUseGrouping() {
      return !isUndefined(this.getMatches().find(function(match) {
        return match === ",";
      }));
    }
  };
}
function CurrencyConverter(options) {
  var mergeTags = function mergeTags2() {
    var string = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var tags = arguments.length > 1 ? arguments[1] : void 0;
    for (var tag in tags) {
      string = string.replace("{{".concat(tag, "}}"), tags[tag]);
    }
    return string;
  };
  var getRatesFromRestApi = function getRatesFromRestApi2(from, to) {
    return getJSON(mergeTags(options.endpoint, {
      from,
      to
    }), {
      headers: options.headers
    });
  };
  return {
    getExchangeRate: function getExchangeRate(from, to) {
      return (isThenable(options.endpoint) ? options.endpoint : getRatesFromRestApi(from, to)).then(function(data) {
        return flattenObject(data)[mergeTags(options.propertyPath, {
          from,
          to
        })];
      });
    }
  };
}
function assert(condition, errorMessage) {
  var ErrorType = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Error;
  if (!condition)
    throw new ErrorType(errorMessage);
}
function assertPercentage(percentage) {
  assert(isPercentage(percentage), "You must provide a numeric value between 0 and 100.", RangeError);
}
function assertValidRatios(ratios) {
  assert(areValidRatios(ratios), "You must provide a non-empty array of numeric values greater than 0.", TypeError);
}
function assertInteger(number) {
  assert(Number.isInteger(number), "You must provide an integer.", TypeError);
}
var calculator$1 = Calculator();
var Dinero = function Dinero2(options) {
  var _Object$assign = Object.assign({}, {
    amount: Dinero2.defaultAmount,
    currency: Dinero2.defaultCurrency,
    precision: Dinero2.defaultPrecision
  }, options), amount = _Object$assign.amount, currency = _Object$assign.currency, precision = _Object$assign.precision;
  assertInteger(amount);
  assertInteger(precision);
  var globalLocale = Dinero2.globalLocale, globalFormat = Dinero2.globalFormat, globalRoundingMode = Dinero2.globalRoundingMode, globalFormatRoundingMode = Dinero2.globalFormatRoundingMode;
  var globalExchangeRatesApi = Object.assign({}, Dinero2.globalExchangeRatesApi);
  var create = function create2(options2) {
    var obj = Object.assign({}, Object.assign({}, {
      amount,
      currency,
      precision
    }, options2), Object.assign({}, {
      locale: this.locale
    }, options2));
    return Object.assign(Dinero2({
      amount: obj.amount,
      currency: obj.currency,
      precision: obj.precision
    }), {
      locale: obj.locale
    });
  };
  var assertSameCurrency = function assertSameCurrency2(comparator) {
    assert(this.hasSameCurrency(comparator), "You must provide a Dinero instance with the same currency.", TypeError);
  };
  return {
    getAmount: function getAmount() {
      return amount;
    },
    getCurrency: function getCurrency() {
      return currency;
    },
    getLocale: function getLocale() {
      return this.locale || globalLocale;
    },
    setLocale: function setLocale(newLocale) {
      return create.call(this, {
        locale: newLocale
      });
    },
    getPrecision: function getPrecision() {
      return precision;
    },
    convertPrecision: function convertPrecision(newPrecision) {
      var roundingMode = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : globalFormatRoundingMode;
      assertInteger(newPrecision);
      var precision2 = this.getPrecision();
      var isNewPrecisionLarger = newPrecision > precision2;
      var operation = isNewPrecisionLarger ? calculator$1.multiply : calculator$1.divide;
      var terms = isNewPrecisionLarger ? [newPrecision, precision2] : [precision2, newPrecision];
      var factor = Math.pow(10, calculator$1.subtract.apply(calculator$1, terms));
      return create.call(this, {
        amount: calculator$1.round(operation(this.getAmount(), factor), roundingMode),
        precision: newPrecision
      });
    },
    add: function add(addend) {
      assertSameCurrency.call(this, addend);
      var addends = Dinero2.normalizePrecision([this, addend]);
      return create.call(this, {
        amount: calculator$1.add(addends[0].getAmount(), addends[1].getAmount()),
        precision: addends[0].getPrecision()
      });
    },
    subtract: function subtract(subtrahend) {
      assertSameCurrency.call(this, subtrahend);
      var subtrahends = Dinero2.normalizePrecision([this, subtrahend]);
      return create.call(this, {
        amount: calculator$1.subtract(subtrahends[0].getAmount(), subtrahends[1].getAmount()),
        precision: subtrahends[0].getPrecision()
      });
    },
    multiply: function multiply(multiplier) {
      var roundingMode = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : globalRoundingMode;
      return create.call(this, {
        amount: calculator$1.round(calculator$1.multiply(this.getAmount(), multiplier), roundingMode)
      });
    },
    divide: function divide(divisor) {
      var roundingMode = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : globalRoundingMode;
      return create.call(this, {
        amount: calculator$1.round(calculator$1.divide(this.getAmount(), divisor), roundingMode)
      });
    },
    percentage: function percentage(_percentage) {
      var roundingMode = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : globalRoundingMode;
      assertPercentage(_percentage);
      return this.multiply(calculator$1.divide(_percentage, 100), roundingMode);
    },
    allocate: function allocate(ratios) {
      var _this = this;
      assertValidRatios(ratios);
      var total = ratios.reduce(function(a, b) {
        return calculator$1.add(a, b);
      });
      var remainder = this.getAmount();
      var shares = ratios.map(function(ratio) {
        var share = Math.floor(calculator$1.divide(calculator$1.multiply(_this.getAmount(), ratio), total));
        remainder = calculator$1.subtract(remainder, share);
        return create.call(_this, {
          amount: share
        });
      });
      var i = 0;
      while (remainder > 0) {
        if (ratios[i] > 0) {
          shares[i] = shares[i].add(create.call(this, {
            amount: 1
          }));
          remainder = calculator$1.subtract(remainder, 1);
        }
        i += 1;
      }
      return shares;
    },
    convert: function convert(currency2) {
      var _this2 = this;
      var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref$endpoint = _ref.endpoint, endpoint = _ref$endpoint === void 0 ? globalExchangeRatesApi.endpoint : _ref$endpoint, _ref$propertyPath = _ref.propertyPath, propertyPath = _ref$propertyPath === void 0 ? globalExchangeRatesApi.propertyPath || "rates.{{to}}" : _ref$propertyPath, _ref$headers = _ref.headers, headers = _ref$headers === void 0 ? globalExchangeRatesApi.headers : _ref$headers, _ref$roundingMode = _ref.roundingMode, roundingMode = _ref$roundingMode === void 0 ? globalRoundingMode : _ref$roundingMode;
      var options2 = Object.assign({}, {
        endpoint,
        propertyPath,
        headers,
        roundingMode
      });
      return CurrencyConverter(options2).getExchangeRate(this.getCurrency(), currency2).then(function(rate) {
        assert(!isUndefined(rate), 'No rate was found for the destination currency "'.concat(currency2, '".'), TypeError);
        return create.call(_this2, {
          amount: calculator$1.round(calculator$1.multiply(_this2.getAmount(), parseFloat(rate)), options2.roundingMode),
          currency: currency2
        });
      });
    },
    equalsTo: function equalsTo(comparator) {
      return this.hasSameAmount(comparator) && this.hasSameCurrency(comparator);
    },
    lessThan: function lessThan(comparator) {
      assertSameCurrency.call(this, comparator);
      var comparators = Dinero2.normalizePrecision([this, comparator]);
      return comparators[0].getAmount() < comparators[1].getAmount();
    },
    lessThanOrEqual: function lessThanOrEqual(comparator) {
      assertSameCurrency.call(this, comparator);
      var comparators = Dinero2.normalizePrecision([this, comparator]);
      return comparators[0].getAmount() <= comparators[1].getAmount();
    },
    greaterThan: function greaterThan(comparator) {
      assertSameCurrency.call(this, comparator);
      var comparators = Dinero2.normalizePrecision([this, comparator]);
      return comparators[0].getAmount() > comparators[1].getAmount();
    },
    greaterThanOrEqual: function greaterThanOrEqual(comparator) {
      assertSameCurrency.call(this, comparator);
      var comparators = Dinero2.normalizePrecision([this, comparator]);
      return comparators[0].getAmount() >= comparators[1].getAmount();
    },
    isZero: function isZero() {
      return this.getAmount() === 0;
    },
    isPositive: function isPositive() {
      return this.getAmount() >= 0;
    },
    isNegative: function isNegative() {
      return this.getAmount() < 0;
    },
    hasSubUnits: function hasSubUnits() {
      return calculator$1.modulo(this.getAmount(), Math.pow(10, precision)) !== 0;
    },
    hasCents: function hasCents() {
      return calculator$1.modulo(this.getAmount(), Math.pow(10, precision)) !== 0;
    },
    hasSameCurrency: function hasSameCurrency(comparator) {
      return this.getCurrency() === comparator.getCurrency();
    },
    hasSameAmount: function hasSameAmount(comparator) {
      var comparators = Dinero2.normalizePrecision([this, comparator]);
      return comparators[0].getAmount() === comparators[1].getAmount();
    },
    toFormat: function toFormat() {
      var format = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : globalFormat;
      var roundingMode = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : globalFormatRoundingMode;
      var formatter = Format(format);
      return this.toRoundedUnit(formatter.getMinimumFractionDigits(), roundingMode).toLocaleString(this.getLocale(), {
        currencyDisplay: formatter.getCurrencyDisplay(),
        useGrouping: formatter.getUseGrouping(),
        minimumFractionDigits: formatter.getMinimumFractionDigits(),
        style: formatter.getStyle(),
        currency: this.getCurrency()
      });
    },
    toUnit: function toUnit() {
      return calculator$1.divide(this.getAmount(), Math.pow(10, precision));
    },
    toRoundedUnit: function toRoundedUnit(digits) {
      var roundingMode = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : globalFormatRoundingMode;
      var factor = Math.pow(10, digits);
      return calculator$1.divide(calculator$1.round(calculator$1.multiply(this.toUnit(), factor), roundingMode), factor);
    },
    toObject: function toObject() {
      return {
        amount,
        currency,
        precision
      };
    },
    toJSON: function toJSON() {
      return this.toObject();
    }
  };
};
var dinero = Object.assign(Dinero, Defaults, Globals, Static);
var dinero_default = dinero;

// src/services/createDinero.ts
var currencyToLocaleMap = {
  AUD: "en-AU",
  BBD: "en-BB",
  BMD: "en-BM",
  BND: "en-BN",
  BSD: "en-BS",
  BZD: "en-BZ",
  CAD: "en-CA",
  FJD: "en-FJ",
  GYD: "en-GY",
  HKD: "en-HK",
  JMD: "en-JM",
  KYD: "en-KY",
  LRD: "en-LR",
  NAD: "en-NA",
  NZD: "en-NZ",
  SBD: "en-SB",
  SGD: "en-SG",
  SRD: "en-SR",
  TTD: "en-TT",
  TWD: "en-TW",
  USD: "en-US",
  XCD: "en-AG",
  ZAR: "en-ZA"
};
var createDinero = (amount, rawCurrency = "AUD", options) => {
  const currency = rawCurrency;
  if (currency in currencyToLocaleMap) {
    return dinero_default(__spreadValues({ amount, currency }, options)).setLocale(
      currencyToLocaleMap[currency]
    );
  }
  return dinero_default(__spreadValues({ amount, currency }, options));
};
